import { Bullet } from '@mv/icons/web';

export type ListItemBulletProps = {
	className?: string;
};

export default function ListItemBullet({ className }: ListItemBulletProps) {
	return <Bullet className={className} size="100" aria-hidden focusable="false" />;
}
